import {
    debrisInStorage, firstUpgradedAmenityInStorage,
    howManyAmenitiesDoIHave,
    howManyFactionBedsDoIHave,
    howManyUpgradedAmenitiesDoIHave,
    howManyUpgradedBedsDoIHave, unUpgradedCoreRoomInStorage
} from '../../../Game/GamePlayerInfo';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseResearch extends WeightedChoiceBase {
    bedCount = 0;
    amenityCount = 0;
    unUpgradedCoreRoom = null;
    debris = false;

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.bedCount = howManyUpgradedBedsDoIHave(this._gamePlayerData);
        this.amenityCount = howManyUpgradedAmenitiesDoIHave(this._gamePlayerData);
        this.unUpgradedCoreRoom = unUpgradedCoreRoomInStorage(this._gamePlayerData);
        this.debris = debrisInStorage(this._gamePlayerData);
    }

    _novice = () => {
        let weight = 0;
        if (this.bedCount < 1) {
            weight += 2;
        }
        this._weight += weight
    }

    _reasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Research', 'Reasonable');

        let weight = 0

        let question = 'Do I need another bed?';
        let answer = false;
        let reasoning = 'I would like 1 bed.';
        if (this.bedCount < 1) {
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Do I need to upgrade a Core Room?';
        answer = false;
        reasoning = 'Upgraded core rooms are very helpful.';
        if (this.unUpgradedCoreRoom != null) {
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Do I need to sell some Debris?';
        answer = false;
        reasoning = 'Researched Debris is worth Snohe.';
        if (this.debris != null) {
            weight += 2
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }

    _persistent = () => {
        let weight = 0
        if (this.bedCount < 1) {
            weight += 3;
        }
        if (this.unUpgradedCoreRoom) {
            weight += 3;
        }
        if (this.amenityCount < 1) {
            weight += 3;
        }
        if (this.debris) {
            weight += 2
        }
        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }
    _unreasonable = () => {
        let weight = 1
        if (this.bedCount < 1) {
            weight += 3;
        } else {
            if (firstUpgradedAmenityInStorage(this._storage) !== null) {
                weight += 3;
            }
            // # if first_upgraded_faction_bed_in_storage(self._storage):
            // #     weight += 3
        }
        if (this.unUpgradedCoreRoom) {
            weight += 3;
        }
        if (this.amenityCount < 1) {
            weight += 3;
        }
        if (this.debris) {
            weight += 3
        }
        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }

    _obsessed = () => {
        this._unreasonable();
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
